// English translations for the accounting + marketing cockpit (French → English).
// The French string IS the key (see lib/i18n.tsx). Strings already in the shared
// `common` dict (Enregistrer, Annuler, Modifier, Supprimer, Date, Statut,
// Client, Tout, Chargement…, etc.) are NOT re-added here.
const m: Record<string, string> = {
  // ── Page chrome ──────────────────────────────────────────────────────────
  'Comptabilité': 'Accounting',
  'Marketing': 'Marketing',
  'Trésorerie, marges et objectifs — pilotage (pas comptabilité fiscale)':
    'Cash, margins and targets — management view (not statutory accounting)',
  'Scanner un reçu': 'Scan a receipt',
  '+ Ajouter une dépense': '+ Add an expense',

  // ── Date range ───────────────────────────────────────────────────────────
  // ('Aujourd’hui', '7 derniers jours', '30 derniers jours', 'Tout' are shared)

  // ── KPI cards (accounting) ───────────────────────────────────────────────
  'Vue d’ensemble': 'Overview',
  'Revenu (livré)': 'Revenue (delivered)',
  '{n} commandes livrées': '{n} orders delivered',
  'Marge brute': 'Gross margin',
  'Revenu − COGS': 'Revenue − COGS',
  'Marge de contribution': 'Contribution margin',
  '− livraison': '− delivery',
  'Bénéfice net': 'Net profit',
  '− fixes − variables': '− fixed − variable',
  'Trésorerie': 'Cash',
  'Position (tout l’historique)': 'Position (all-time)',

  // ── Trend ────────────────────────────────────────────────────────────────
  'Contribution par jour': 'Contribution per day',
  'contribution': 'contribution',

  // ── P&L statement ────────────────────────────────────────────────────────
  'Compte de résultat (période)': 'Income statement (period)',
  'Compte de résultat': 'Income statement',
  'Coût de revient (COGS)': 'Cost of goods sold (COGS)',
  'Livraison': 'Delivery',
  'Charges fixes / récurrentes': 'Fixed / recurring costs',
  'Charges variables': 'Variable costs',
  'Coût d’acquisition (pub)': 'Acquisition cost (ads)',
  'dépenses publicitaires': 'advertising spend',
  'Bénéfice net après pub': 'Net profit after ads',
  'Achats ponctuels — hors P&L mensuel': 'One-off purchases — outside monthly P&L',
  'capex': 'capex',

  // ── Per-album averages ─────────────────────────────────────────────────────
  'Par album (moyenne)': 'Per album (average)',
  'Revenu moyen / album': 'Avg revenue / album',
  'Coût moyen / album': 'Avg cost / album',
  'COGS + livraison + pub': 'COGS + delivery + ads',
  'Profit moyen / album': 'Avg profit / album',
  'après coût pub': 'after ad cost',
  'Albums (période)': 'Albums (period)',
  'Coût pub / lead (CPL)': 'Ad cost / lead (CPL)',
  'Coût pub / album': 'Ad cost / album',
  'Profit par album = après coût pub. Les charges fixes / récurrentes':
    'Profit per album = after ad cost. Fixed / recurring costs',
  'restent au niveau de la période et ne sont pas réparties par album.':
    'stay at the period level and are not split per album.',
  'Aucun album livré sur la période.': 'No albums delivered in this period.',

  // ── Cash flow ────────────────────────────────────────────────────────────
  'Flux de trésorerie': 'Cash flow',
  'Encaissements (avances + COD)': 'Cash in (deposits + COD)',
  'dont avances': 'of which deposits',
  'dont solde COD livré': 'of which delivered COD balance',
  'Décaissements (dépenses)': 'Cash out (expenses)',
  'Position de trésorerie': 'Cash position',
  'Burn mensuel': 'Monthly burn',
  'Runway': 'Runway',
  '{n} mois': '{n} months',

  // ── Targets ──────────────────────────────────────────────────────────────
  'Objectifs': 'Targets',
  'Objectif de bénéfice': 'Profit target',
  'Objectif de bénéfice / jour (MAD)': 'Profit target / day (MAD)',
  'Commandes / jour nécessaires': 'Orders / day needed',
  'Contribution moy. / commande': 'Avg. contribution / order',
  'Panier moyen (AOV)': 'Average order value (AOV)',
  'Cette semaine': 'This week',
  'Ce mois': 'This month',
  'd’avance': 'ahead',
  'd’écart': 'short',

  // ── Expense category breakdown ───────────────────────────────────────────
  'Dépenses par catégorie (période)': 'Expenses by category (period)',
  'Répartition': 'Breakdown',

  // ── Expense list ─────────────────────────────────────────────────────────
  'Dépenses': 'Expenses',
  'Toutes': 'All',
  'Aucune dépense sur cette période.': 'No expenses in this period.',
  'Supprimer cette dépense ?': 'Delete this expense?',

  // ── Expense categories ───────────────────────────────────────────────────
  'Loyer': 'Rent',
  'Électricité': 'Electricity',
  'Internet / Wifi': 'Internet / Wifi',
  'Salaires': 'Salaries',
  'Logiciels': 'Software',
  'Machine / Matériel': 'Machine / Equipment',
  'Publicité': 'Advertising',
  'Autre': 'Other',

  // ── Expense kinds ────────────────────────────────────────────────────────
  'Récurrente': 'Recurring',
  'Variable': 'Variable',
  'Ponctuelle': 'One-off',

  // ── Expense form modal ───────────────────────────────────────────────────
  'Modifier la dépense': 'Edit expense',
  'Ajouter une dépense': 'Add an expense',
  'Type': 'Type',
  'Investissement ponctuel — exclu du bénéfice net mensuel.':
    'One-off investment — excluded from monthly net profit.',
  'Catégorie': 'Category',
  'Montant (MAD)': 'Amount (MAD)',
  'Fournisseur': 'Vendor',
  'Libellé': 'Label',
  'Notes': 'Notes',
  'Optionnel': 'Optional',

  // ── Receipt scan modal ───────────────────────────────────────────────────
  'Scanner un reçu de dépense': 'Scan an expense receipt',
  'Prenez en photo le reçu / la facture de dépense. L’IA lit le montant et la catégorie, puis':
    'Take a photo of the expense receipt / invoice. The AI reads the amount and category, then',
  'vous validez': 'you confirm',
  'avant d’enregistrer — rien n’est enregistré automatiquement.':
    'before saving — nothing is saved automatically.',
  'Lecture du reçu en cours…': 'Reading receipt…',
  'Prendre une photo / choisir une image': 'Take a photo / choose an image',
  'L’IA analyse l’image…': 'The AI is analysing the image…',
  'Vérifiez la dépense extraite, puis validez.': 'Review the extracted expense, then confirm.',
  'Nom du fournisseur': 'Vendor name',
  'Mensuelle fixe (loyer, salaires…)': 'Fixed monthly (rent, salaries…)',
  'Ponctuelle variable (pub, achats…)': 'Variable one-off (ads, purchases…)',
  'Investissement (hors P&L mensuel)': 'Investment (outside monthly P&L)',
  '← Reprendre une photo': '← Retake a photo',
  'Valider la dépense': 'Confirm the expense',

  // ── Marketing toolbar ────────────────────────────────────────────────────
  'Synchroniser les dépenses': 'Sync spend',
  '+ Dépense (manuel)': '+ Spend (manual)',
  'Importer CSV': 'Import CSV',
  'erreur': 'error',

  // ── Marketing KPI cards ──────────────────────────────────────────────────
  'Acquisition — vue d’ensemble': 'Acquisition — overview',
  'Dépense pub': 'Ad spend',
  '{n} leads': '{n} leads',
  'CAC réel': 'True CAC',
  '{n} confirmés': '{n} confirmed',
  'par lead': 'per lead',
  'revenu / dépense': 'revenue / spend',
  'Contrib. après pub': 'Contrib. after ads',

  // ── Marketing tables ─────────────────────────────────────────────────────
  'Par canal': 'By channel',
  'Canaux': 'Channels',
  'Par campagne': 'By campaign',
  'Campagnes (triable)': 'Campaigns (sortable)',
  'Canal': 'Channel',
  'Campagne': 'Campaign',
  'Dépense': 'Spend',
  'Leads': 'Leads',
  'Confirmés': 'Confirmed',
  'Aucune donnée sur cette période.': 'No data in this period.',

  // ── Channel labels ───────────────────────────────────────────────────────
  'Direct': 'Direct',

  // ── Manual spend modal ───────────────────────────────────────────────────
  'Ajouter une dépense (manuel)': 'Add spend (manual)',
  'Plateforme': 'Platform',
  'Campagne (= utm_campaign pour le rapprochement)':
    'Campaign (= utm_campaign for matching)',
  'Nom de campagne': 'Campaign name',
  'Dépense (MAD)': 'Spend (MAD)',
  'Impressions': 'Impressions',
  'Clics': 'Clicks',

  // ── CSV / XLSX import modal ──────────────────────────────────────────────
  'Importer des dépenses (CSV)': 'Import spend (CSV)',
  'Importer des dépenses (CSV / Excel)': 'Import spend (CSV / Excel)',
  'En-têtes:': 'Headers:',
  '— channel ∈ facebook/tiktok/google, date YYYY-MM-DD.':
    '— channel ∈ facebook/tiktok/google, date YYYY-MM-DD.',
  'Colonnes reconnues:': 'Recognised columns:',
  '— channel ∈ facebook/tiktok/google.': '— channel ∈ facebook/tiktok/google.',
  'Glissez un fichier ici ou cliquez pour choisir': 'Drag a file here or click to choose',
  'CSV, XLSX ou XLS': 'CSV, XLSX or XLS',
  'Retirer': 'Remove',
  'Aucune ligne lisible. Vérifiez les en-têtes du fichier.':
    'No readable rows. Check the file headers.',
  'Fichier illisible.': 'Unreadable file.',
  '… ou collez du CSV:': '… or paste CSV:',
  '{n} ligne(s) détectée(s).': '{n} line(s) detected.',
  '{n} ignorée(s) (données incomplètes).': '{n} skipped (incomplete data).',
  '+{n} de plus…': '+{n} more…',
  'Importer': 'Import',
  '{imported} importée(s), {skipped} ignorée(s).':
    '{imported} imported, {skipped} skipped.',
  '— channel ∈ facebook/meta, tiktok, google, organic.':
    '— channel ∈ facebook/meta, tiktok, google, organic.',
  'Modèle CSV': 'CSV template',
  'Devise par défaut': 'Default currency',
  '(converti en MAD)': '(converted to MAD)',
  'Canal par défaut': 'Default channel',
  '(si pas de colonne canal)': '(if no channel column)',
  'Pas de colonne « channel » — le canal par défaut ci-dessus sera appliqué à toutes les lignes.':
    'No "channel" column — the default channel above will be applied to every row.',
  'Délimiteur': 'Delimiter',
  'En-têtes': 'Headers',
  'Colonne « channel » introuvable — vérifiez les en-têtes ou téléchargez le modèle.':
    'No "channel" column found — check the headers or download the template.',

  // ── FX rates ─────────────────────────────────────────────────────────────
  'Taux de change → MAD': 'Exchange rate → MAD',
  'Meta facture en USD. Tous les montants sont convertis en MAD avec ce taux.':
    'Meta bills in USD. All amounts are converted to MAD using this rate.',
  'Enregistrer les taux': 'Save rates',
  'Enregistrer recalcule toutes les dépenses en MAD.':
    'Saving recalculates all spend into MAD.',

  // ── Ad-accounts panel ────────────────────────────────────────────────────
  'Comptes publicitaires': 'Ad accounts',
  'Identifiants de compte (non secrets). Les': 'Account identifiers (non-secret). The',
  'jetons API': 'API tokens',
  'se configurent en secret worker': 'are configured as worker secrets',
  'Ad Account ID (act_…)': 'Ad Account ID (act_…)',
  'Pixel ID (Conversions API)': 'Pixel ID (Conversions API)',
  'Requis pour envoyer les conversions confirmées à Meta.':
    'Required to send confirmed conversions to Meta.',
  'Advertiser ID': 'Advertiser ID',
  'Pixel ID / Event Set ID (Events API)': 'Pixel ID / Event Set ID (Events API)',
  'Requis pour envoyer les conversions confirmées à TikTok.':
    'Required to send confirmed conversions to TikTok.',
  'Customer ID': 'Customer ID',
  'Login Customer ID (compte manager, optionnel)':
    'Login Customer ID (manager account, optional)',
  'Conversion Action ID (conversions hors-ligne)':
    'Conversion Action ID (offline conversions)',
  'Requis pour téléverser les conversions à Google. Nécessite un gclid sur la commande.':
    'Required to upload conversions to Google. Requires a gclid on the order.',
  '● Token': '● Token',
  '○ Token (secret)': '○ Token (secret)',
  '● Pixel/ID': '● Pixel/ID',
  '○ Pixel/ID': '○ Pixel/ID',
  'Actif': 'Active',

  // ── Conversions audit panel ──────────────────────────────────────────────
  'Conversions envoyées': 'Conversions sent',
  'Signal serveur (Meta CAPI · TikTok Events · Google offline) à la confirmation de la commande payante.':
    'Server-side signal (Meta CAPI · TikTok Events · Google offline) on paid-order confirmation.',
  'Tous canaux': 'All channels',
  'Commande': 'Order',
  'Événement': 'Event',
  'Valeur': 'Value',
  'Clé': 'Key',
  'Action': 'Action',
  'Aucune conversion sur cette période.': 'No conversions in this period.',
  'Réessayer': 'Retry',
  // Conversion event labels ('Livré' is in the shared common dict)
  'Achat confirmé': 'Confirmed purchase',
  // Conversion match keys
  'téléphone (hashé)': 'phone (hashed)',
  // Conversion result statuses
  'Envoyé': 'Sent',
  'Ignoré': 'Skipped',
  'Erreur': 'Error',
};
export default m;
